var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',_vm._b({staticClass:"text-subtitle-1"},'label',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }